import { FileExcelFilled } from '@ant-design/icons';
import { Button, Form, Input, Radio, Select } from 'antd';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
import { getUserList, UserFilter } from 'api/master';
import xlsx from 'json-as-xlsx';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserList from '../UserList';

type Props = {
  isLoading: boolean;
  onSubmit: (values: UserFilter) => Promise<void>;
};
const initPartners: SelectList[] = [];

const filterPayload: UserFilter = {};

const User = ({ onSubmit }: Props) => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [filter, setFilter] = useState(filterPayload);
  //const [_isSearch, setSearch] = useState(false);
  const [form] = Form.useForm<UserFilter>();
  //const [_isReset, setReset] = useState(false);
  const [adminList, setAdminList] = useState(initPartners);

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin');
    const roleAdminPayload: SelectPayload = {
      SKey: isAdmin == 'true' ? 'AllPartnerRole' : 'AdminRole',
    };

    getSelectList(roleAdminPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setAdminList(res.data);
    });
  }, []);
  const handleSubmit = useCallback(
    async (values: UserFilter) => {
      debugger;
      let updatedValues = { ...values };
      updatedValues.partnerId = sessionStorage.getItem('partnerId')?.toString();
      //updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      // let updatedFilter = { ...filter };
      // updatedFilter = filterPayload;
      setFilter(updatedValues);
      //form.resetFields();
    },
    [onSubmit, form]
  );

  const handleSource = () => {
    navigate('/app/profile/add-user');
  };

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }

  function handleDownload(_e: any) {
    let settings = {
      fileName: 'UserListReport', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
      RTL: false, // Display the columns from right-to-left (the default value is false)
    };
    filter.isExtract = true;
    let data: any[] = [];
    //  const list: UserFilter = {
    //     userId: Number(sessionStorage.getItem('userId')?.toString()),
    //    partnerId: Number(sessionStorage.getItem('partnerId')?.toString()),
    //  };
    getUserList(filter).then((res) => {
      debugger;

      res.data.data.forEach((e) => {
        e.isActive = e.isActive ? 'Active' : 'InActive';
      });

      if (res) {
        data = [
          {
            sheet: 'Sheet 1',
            columns: [
              { label: 'Name', value: 'name' },
              { label: 'Email Id', value: 'emailId' },
              { label: 'Role', value: 'roleName' },
              // { label: 'Link Sent Date', value: 'linkSentDate' },
              { label: 'Is Active', value: 'isActive' },
            ],
            content: res.data.data,
          },
        ];
        xlsx(data, settings);
      }
    });
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>User Master</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<UserFilter>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  // initialValues={{
                  //     ['Username']: sessionStorage.getItem('user')?.toString(),
                  //     //['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
                  // }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Name :'} name="name" className="fieldTitle">
                          <Input placeholder={'Name'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Role :'} name="roleId" className="fieldTitle">
                          <Select size="large" placeholder={'Select'}>
                            {adminList.map((role) => (
                              <>
                                <Option value={role.SValue}>{role.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Type :'} name="isActive" className="fieldTitle">
                          <Radio.Group>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="IsActive"
                                type="radio"
                                value={'true'}
                                style={{ width: '600px', color: 'white', fontWeight: '' }}
                              >
                                {' '}
                                Active
                              </Radio>
                            </label>
                            <label
                              className="btn btn-primary col-md-2"
                              style={{ marginRight: '10px', marginBottom: '20px' }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="appType"
                                name="IsActive"
                                type="radio"
                                value={'false'}
                                style={{ width: '300px', color: 'white' }}
                              >
                                InActive
                              </Radio>
                            </label>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <Form.Item label={''} className="fieldTitle">
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{ fontSize: '12px', color: 'green', float: 'right' }}
                        onClick={handleDownload}
                        title={'Download User List Report'}
                      ></Button>
                      <Button
                        type="primary"
                        onClick={handleSource}
                        style={{ float: 'right', marginRight: '5px' }}
                      >
                        {'CREATE USER'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        onClick={handleReset}
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'CLEAR'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'SEARCH'}
                      </Button>
                      &nbsp; &nbsp;
                    </Form.Item>
                  </div>
                </Form>
              </div>
              <UserList filter={{ ...filter }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
